import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';

class TituloFilete extends React.Component {
  render() {
    const TituloSt = styled.div`
      margin: 4em 0 1em 0;
      position: relative;
    `;
    const Titulo = styled.h3`
      color: ${colors.black};
      font-size: 1.6em;
      margin: 0;
      padding: 0;
      &:before {
        display: block;
        content: '';
        width: 40px;
        height: 5px;
        position: absolute;
        top: -50px;
        background: ${colors.black};
        margin: 1em 0 0 0;
      }
    `;
    const Clave = styled.p`
      color: ${colors.main};
      text-transform: uppercase;
      letter-spacing: 1px;
      margin: 0;
      padding: 0;
    `;

    return (
      <TituloSt>
        <Titulo>{this.props.titulo}</Titulo>
        <Clave>{this.props.clave}</Clave>
      </TituloSt>
    );
  }
}

export default TituloFilete;



// WEBPACK FOOTER //
// ./src/components/TituloFilete.js